module.exports = __webpack_public_path__ + "img/electroplating-chemical.b6c7e39b.webp";